import * as React from "react";
import {useContext} from "react";
import {OktaEnvContext} from "../OktaEnvContext";

export const HelpText = () => {

    const oktaConfig = useContext(OktaEnvContext);

    return <>
        <p>If you are experiencing trouble accessing a Media Center, it may be due to your account or a
            missing login, please follow the steps:</p>
        <ol>
            <li>
                Double-check your login credentials. Ensure that you have entered your username and
                password correctly. Pay attention to capitalization and spacing.
            </li>
            <li>
                Contact the Sartorius Team (sartoriusid@sartorius.com) for support and to confirm that
                your account has access to the Media Center. (Please include the URL of the Media Center
                you are trying to Access)
            </li>
        </ol>
        <p>If you do not have an account for the Sartorius Media Center, please request a My Sartorius
            account first. Click&nbsp;
            <a href={oktaConfig.registrationLink} target="_blank" rel="noreferrer">
                here
            </a>
            &nbsp;
            to request a My Sartorius Account first.
            Once your account is set up, you can access the Media Center via My Sartorius.</p>
        <p>If you need any help, please contact your Sartorius channel manager or sartoriusid@sartorius.com.</p>
    </>
}
